export const SET_KIOSK_ID_AND_GET_MENUS_DATA_REQUEST = 'SET_KIOSK_ID_AND_GET_MENUS_DATA_REQUEST';
export const SET_KIOSK_ID_AND_GET_MENUS_DATA_RESPONSE = 'SET_KIOSK_ID_AND_GET_MENUS_DATA_RESPONSE';
export const SET_LANGUAGE_REQUEST = 'SET_LANGUAGE_REQUEST';
export const SET_LANGUAGE_RESPONSE = 'SET_LANGUAGE_RESPONSE';
export const SET_KIOSK_MENU_SELECTION_REQUEST = 'SET_KIOSK_MENU_SELECTION_REQUEST';
export const SET_KIOSK_MENU_SELECTION_RESPONCE = 'SET_KIOSK_MENU_SELECTION_RESPONCE'
export const EXIT_ACTION = 'EXIT_ACTION';
export const SET_LOADING = 'SET_LOADING';
export const BACK_ACTION_REQUEST = 'BACK_ACTION_REQUEST';
export const BACK_ACTION_RESPONSE = 'BACK_ACTION_RESPONSE';
export const SUSPEND_ERROR_METHOD = 'SUSPEND_ERROR_METHOD';
export const MRN_SUBMIT_REQUEST = 'MRN_SUBMIT_REQUEST';
export const MRN_SUBMIT_RESPONSE = 'MRN_SUBMIT_RESPONSE';
export const TOKEN_TEMPLATE_AREA_RESPONSE = 'TOKEN_TEMPLATE_AREA_RESPONSE';
export const APPOINTMENTS_AREA_RESPONSE = 'APPOINTMENTS_AREA_RESPONSE';
export const SELECTED_KIOSK_MODE = 'SELECTED_KIOSK_MODE';
export const APPOINTMENT_CHECKEIN_REQUEST = 'APPOINTMENT_CHECKEIN_REQUEST';
export const APPOINTMENT_CHECKEIN_RESPONSE = 'APPOINTMENT_CHECKEIN_RESPONSE';
export const GET_CURRENT_DATE_TIME_REQUEST = 'GET_CURRENT_DATE_TIME_REQUEST';
export const GET_CURRENT_DATE_TIME_RESPONSE = 'GET_CURRENT_DATE_TIME_RESPONSE';
export const GET_FEEDBACK_REQUEST = 'GET_FEEDBACK_REQUEST';
export const GET_FEEDBACK_RESPONSE = 'GET_FEEDBACK_RESPONSE';

export const GET_EMIRATES_ID_REQUEST = 'GET_EMIRATES_ID_REQUEST';
export const GET_EMIRATES_ID_RESPONSE = 'GET_EMIRATES_ID_RESPONSE';

export const GET_PAYMENT_DETAILS_REQUEST = 'GET_PAYMENT_DETAILS_REQUEST';
export const GET_PAYMENT_DETAILS_RESPONSE = 'GET_PAYMENT_DETAILS_RESPONSE';
export const GET_PAYMENT_MODE = "GET_PAYMENT_MODE"

export const GET_DEPARTMENTS_REQUEST = 'GET_DEPARTMENTS_REQUEST';
export const GET_DEPARTMENTS_RESPONSE = 'GET_DEPARTMENTS_RESPONSE';

export const GET_DOCTORS_REQUEST = 'GET_DOCTORS_REQUEST';
export const GET_DOCTORS_RESPONSE = 'GET_DOCTORS_RESPONSE';

export const SEARCHKEY = 'SEARCHKEY';
export const SELECTEEDOCTOR = 'SELECTEEDOCTOR';
export const SELECTEDTIME = 'SELECTEDTIME';

export const WALKIN_APPOINTMENT_REQUEST = 'WALKIN_APPOINTMENT_REQUEST';
export const WALKIN_APPOINTMENT_RESPONSE = 'WALKIN_APPOINTMENT_RESPONSE';

export const IS_DOB_AUTHENTICATION_ACTION = 'IS_DOB_AUTHENTICATION_ACTION';

export const VERIFY_INPUT_REQUEST = "VERIFY_INPUT_REQUEST";
export const VERIFY_INPUT_RSPONSE = "VERIFY_INPUT_RSPONSE";

export const IDLE_ERROR_MESSAGE = 'IDLE_ERROR_MESSAGE';
export const KIOSK_REFRESH_TIME_UPDATE = 'KIOSK_REFRESH_TIME_UPDATE';
export const SET_RESET_FOR_KIOSK_START_TIME_AND_END_TIME = "SET_RESET_FOR_KIOSK_START_TIME_AND_END_TIME"

export const REDIRECT_PAGE = "REDIRECT_PAGE";
export const CANCEL_ALL_PENDING_REQUESTS = "CANCEL_ALL_PENDING_REQUESTS";

export const FIRSPASSWELCOMEPAGE = "FIRSPASSWELCOMEPAGE";

export const PRINT_TOKEN_REQUEST = "PRINT_TOKEN_REQUEST";
export const PRINT_TOKEN_RESPONSE = "PRINT_TOKEN_RESPONSE";